module.exports = "<p *ngIf=\"!ivalidSignin\">\r\n  Loading...\r\n</p>\r\n<div *ngIf=\"ivalidSignin\">\r\n  <app-signin></app-signin>\r\n</div>"